import { render, staticRenderFns } from "./AddVariationPopup.vue?vue&type=template&id=52e64e5e"
import script from "./AddVariationPopup.vue?vue&type=script&lang=js"
export * from "./AddVariationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports